import axios from "axios";

interface INetworkDownloadRaParams {
    filters?: any,
    fields: {
        field: string,
        headerName: string
    }[]
}

interface INetworkDownloadRaReturn {
    file: any,
    fileName: string
}

export const downloadNetworkRa = async (params: INetworkDownloadRaParams): Promise<INetworkDownloadRaReturn> => {
    const response = await axios.post(
        '/network/ra/basic-export',
        params,
        {
            responseType: 'blob'
        }
    );
    const contentDisposition = response.headers['content-disposition'];
    const fileName = contentDisposition.match(/filename="(.*)"/)?.[1] ?? 'unknown';
    return {
        file: response.data,
        fileName
    };
};